import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dependsOn: String,
    blocks: String
  }

  connect() {
    this.canvas = document.getElementById("dependencies-canvas")
  }

  highlight() {
    const allRows = document.querySelectorAll(".nested-sortable-item")

    allRows.forEach(row => row.classList.add("opacity-80", "transition-opacity", "duration-200"))

    this.element.classList.remove("opacity-80")
    this.element.classList.add("bg-slate-50", "ring-1", "ring-slate-100", "z-10")

    this.clearArrows()

    if (this.dependsOnValue) {
      const parentIds = this.dependsOnValue.split(",")
      parentIds.forEach(id => {
        const parentRow = document.getElementById(`entry_${id}`)
        if (parentRow) {
          parentRow.classList.remove("opacity-80")
          parentRow.classList.add("bg-amber-50/50", "ring-1", "ring-amber-200", "z-10")

          this.drawArrow(parentRow, this.element, "#f59e0b", "url(#arrowhead)")
        }
      })
    }

    if (this.blocksValue) {
      const childIds = this.blocksValue.split(",")
      childIds.forEach(id => {
        const childRow = document.getElementById(`entry_${id}`)
        if (childRow) {
          childRow.classList.remove("opacity-80")
          childRow.classList.add("bg-blue-50/50", "ring-1", "ring-blue-200", "z-10")

          this.drawArrow(this.element, childRow, "#3b82f6", "url(#arrowhead-blue)")
        }
      })
    }
  }

  clear() {
    const allRows = document.querySelectorAll(".nested-sortable-item")

    allRows.forEach(row => {
      row.classList.remove(
        "opacity-80", "bg-slate-50", "ring-1", "ring-slate-100",
        "bg-amber-50/50", "ring-1", "ring-amber-200",
        "bg-blue-50/50", "ring-1", "ring-blue-200", "z-10"
      )
    })

    this.clearArrows()
  }

  drawArrow(fromEl, toEl, color, markerId) {
    if (!this.canvas) return

    const fromRect = fromEl.getBoundingClientRect()
    const toRect = toEl.getBoundingClientRect()

    if (fromRect.top === 0 || toRect.top === 0) return

    const startX = fromRect.left - 6
    const endX = toRect.left - 6

    const startY = fromRect.top + (fromRect.height / 2)
    const endY = toRect.top + (toRect.height / 2)
    
    const deltaY = Math.abs(startY - endY)
    
    const bend = Math.max(30, Math.min(100, deltaY * 0.4))
    
    const controlX1 = startX - bend
    const controlX2 = endX - bend

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path")
    
    const dAttr = `M ${startX} ${startY} 
                 C ${controlX1} ${startY}, ${controlX2} ${endY}, 
                 ${endX} ${endY}`

    path.setAttribute("d", dAttr)
    path.setAttribute("stroke", color)
    path.setAttribute("stroke-width", "1.5")
    path.setAttribute("stroke-dasharray", "4 3")
    path.setAttribute("fill", "none")
    path.setAttribute("marker-end", markerId)
    path.setAttribute("class", "dependency-svg-arrow")

    this.canvas.appendChild(path)
  }


  clearArrows() {
    if (!this.canvas) return
    const arrows = this.canvas.querySelectorAll(".dependency-svg-arrow")
    arrows.forEach(arrow => arrow.remove())
  }
}
